import React from 'react';
import classnames from 'classnames';
import { startCase } from 'lodash';
import { ResponsiveContainer, BarChart as ReBarChart, XAxis, YAxis, CartesianGrid, Tooltip, Bar } from 'recharts';
import GlobalProps from '../globalProps';

import './BarChart.css';

interface Props extends GlobalProps {
  data: Array<{ [key: string]: string | number }>;
}

const chartColors = ['var(--color-ticket-available)', 'var(--color-success)'];

export function BarChart({ data, className, style }: Props): JSX.Element {
  return (
    <div className={classnames('bar-chart', className)} style={style}>
      <ResponsiveContainer width="100%" height="100%">
        <ReBarChart data={data}>
          <CartesianGrid />
          <Tooltip />
          {Object.keys(data[0] ?? {})
            .filter((key) => key !== 'name')
            .map((key, index) => {
              return <Bar key={`${key}`} dataKey={key} name={`${startCase(key)}`} fill={chartColors[index]} />;
            })}

          <XAxis dataKey="name" axisLine={false} tickLine={false} padding={{ left: 16, right: 16 }} />
          <YAxis orientation={'left'} width={40} allowDecimals={false} axisLine={false} tickLine={false} />
        </ReBarChart>
      </ResponsiveContainer>
    </div>
  );
}
